import { createContext } from "react";


const ProjectsContext = createContext();


export default ProjectsContext;